import { render, staticRenderFns } from "./HomeAddons.vue?vue&type=template&id=3e4ed0d0&"
import script from "./HomeAddons.vue?vue&type=script&lang=js&"
export * from "./HomeAddons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports